
import Vue from 'vue';
import pdf from 'vue-pdf';
import axios from 'axios';
import _ from 'lodash';

export default Vue.extend({
  components: { pdf },
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data(): { loading: boolean } {
    return { loading: false };
  },
  computed: {
    disabled: function(): boolean {
      return this.rowDisabled || this.parent._getDisableStatus(this.input.disabled) || this.loading;
    },
    fileName: function() : string {
      const fileDetails = this.getVariable(this.input.variable);
      if (fileDetails) {
        return fileDetails.name;
      } else {
        return '';
      }
    },
    fileLink: function(): string {
      const fileDetails = this.getVariable(this.input.variable);
      if (fileDetails) {
        return fileDetails.url;
      } else {
        return '';
      }
    },
    fileType: function(): string {
      if(!this.fileName) {
        return '';
      } else {
        if(this.fileName.endsWith('pdf')) {
          return 'pdf';
        } else {
          return 'image';
        }
      }
    }
  },
  methods: {
    /** 
     * uploads file to server, invoked indirectly from `fnUpload`
     */
    _uploadFile: async function() {
      try {
        // @ts-ignore
        const file = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append('file', file);
        this.loading = true;
        const response = await axios.post('/api/v1/upload', formData);
        const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
        this.$set(this.parent._getVariable(prefix), key, { name: response.data.filename });
      } catch (error) {
        this.$store.commit('setSnackbar', { serverMessage: _.get(error, 'response.data.error') || _.get(error, 'message'), show: true, color: 'error' });        
      }
      this.loading = false;
    },
    deleteFile: function() {
      const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
      this.$set(this.parent._getVariable(prefix), key, '');
      // @ts-ignore
      this.$refs.file.value = '';
    },
    /**
     * function to be executed when button clicked, which decides the next step based on type of button
     */
    onButtonClick() {
      // @ts-ignore
      this.$refs.file.click();
    }
  }
});
